import React, { useState } from 'react';
import { useQuery } from 'react-query';

import dayjs from 'dayjs';
import styled from 'styled-components';

import { getSnapshot } from 'apis/SnapshotsAPI';
import { SnapshotDataType } from 'types/snapshot';

import { useEditShopRequestModalContext } from './EditShopRequestModalContext';
import { SNAPSHOT_SELECTOR_SELECTION } from '../../../common/Snapshot/editor/constants';
import Button from '../../lib/Button';
import ShopDataModal from '../../ShopData/ShopDataModal';
import { SHOP_REQUEST_STATUS_LABELS } from '../constants';

const Container = styled.div`
  width: 100%;
  display: flex;
`;

const StyledButton = styled(Button)`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: center;
  margin: 15px 20px 0 30px;
  flex-grow: 1;

  img {
    margin-right: 6.5px;
    width: 24px;
    height: 24px;
  }
`;

const EditShopRequestModalEnterData = () => {
  const { originalShopRequest, shopRequest, setShopRequest, refetchShopRequests } = useEditShopRequestModalContext();
  const [showShopDataModal, setShowDataModal] = useState(false);

  const openModal = () => setShowDataModal(true);
  const closeModal = () => setShowDataModal(false);

  const { data: shopRequestSnapshot, isLoading } = useQuery({
    queryKey: ['snapshot', 'editShopRequest', shopRequest?.snapshot],
    queryFn: () => getSnapshot(shopRequest!.snapshot!),
    enabled: Boolean(shopRequest?.snapshot),
    refetchOnWindowFocus: false,
  });

  const viewOnly = [SHOP_REQUEST_STATUS_LABELS.NOT_STARTED, SHOP_REQUEST_STATUS_LABELS.NEEDS_APPROVAL].includes(
    originalShopRequest?.status || 0
  );
  const disabled =
    isLoading ||
    [SHOP_REQUEST_STATUS_LABELS.APPROVED, SHOP_REQUEST_STATUS_LABELS.CANCELED].includes(
      originalShopRequest?.status || 0
    );

  return (
    <Container>
      <StyledButton onClick={openModal} disabled={disabled} loading={isLoading}>
        <img src="/icons/auto-fix-high.svg" />
        Enter Shop Data
      </StyledButton>
      {Boolean(originalShopRequest?.community && showShopDataModal) && (
        <ShopDataModal
          communityId={originalShopRequest!.community!.id}
          snapshot={shopRequestSnapshot}
          open={showShopDataModal}
          mode={SNAPSHOT_SELECTOR_SELECTION.ENTER_SHOP_DATA}
          date={dayjs(new Date())}
          shopRequestId={shopRequest?.id}
          draft
          disabled={viewOnly}
          onCreate={(snapshot: SnapshotDataType) => {
            if (shopRequest && snapshot) {
              setShopRequest({ ...shopRequest, snapshot: snapshot.id });
              refetchShopRequests();
            }
            closeModal();
          }}
          onClose={closeModal}
        />
      )}
    </Container>
  );
};

export default EditShopRequestModalEnterData;
